export const SnackBarTime = {
    fast: 2000,
    medium: 4000,
    slow: 8000,
};
